import Swiper, { Navigation, Pagination, Lazy, Autoplay, startAutoplay, Grid } from 'swiper';

Swiper.use([Navigation, Pagination, Lazy, Autoplay, startAutoplay, Grid]);

const homeFunctions = {
  /**
   * Faz a montagem do carousel dos banners full princiais
  */
  setFullbanner: () => {
      const fullbanners = document.querySelectorAll('[data-fullbanner-swiper]');
  
      fullbanners.forEach((section) => {
        const carousel = section.querySelector('.swiper');
        const pagination = section.querySelector('.swiper-pagination');
  
        const swiper = new Swiper(carousel, {
          slidesPerView: 1,
          watchOverflow: true,
          speed: 1000,
          autoplay: {
              delay: 5000
          },
          preloadImages: false,
          lazy: {
            checkInView: true,
            loadPrevNext: true,
            loadOnTransitionStart: true,
            loadPrevNextAmount: 1,
          },
          pagination: {
            el: pagination,
            type: 'bullets',
            clickable: true,
          },
        });

        swiper.on('slideChange', function() {
          swiper.pagination.render();
          swiper.pagination.update();
        });
      });
  },

  /**
   * Faz a montagem do carousel dos banners de categorias
  */
  setBannersCategories: () => {
    const bannersCategories = document.querySelectorAll('[data-categories-swiper]');

    bannersCategories.forEach((section) => {
      const carousel = section.querySelector('.swiper');
      const next = section.querySelector('.swiper-button-categories-next');
      const prev = section.querySelector('.swiper-button-categories-prev');

      const swiper = new Swiper(carousel, {
        slidesPerView: 3,
        navigation: {
          nextEl: next,
          prevEl: prev,
        },
        watchOverflow: true,
        preloadImages: false,
        lazy: {
          checkInView: true,
          loadPrevNext: true,
          loadOnTransitionStart: true,
          loadPrevNextAmount: 1,
        },
        breakpoints: {
          1200: {
            slidesPerView: 7,
          },
          1024: {
            slidesPerView: 5,
          },
          768: {
            slidesPerView: 4
          },
        },
      });
    });
  },

  /**
   * Faz a montagem do carousel dos banners de marcas
  */
  setBannersBrands: () => {
    const bannersBrands = document.querySelectorAll('[data-brands-swiper]');

    bannersBrands.forEach((section) => {
      const carousel = section.querySelector('.swiper');
      const next = section.querySelector('.swiper-button-brands-next');
      const prev = section.querySelector('.swiper-button-brands-prev');

      const swiper = new Swiper(carousel, {
        slidesPerView: 3,
        navigation: {
          nextEl: next,
          prevEl: prev,
        },
        watchOverflow: true,
        preloadImages: false,
        lazy: {
          checkInView: true,
          loadPrevNext: true,
          loadOnTransitionStart: true,
          loadPrevNextAmount: 1,
        },
        breakpoints: {
          1200: {
            slidesPerView: 6,
          },
          1024: {
            slidesPerView: 5,
          },
          768: {
            slidesPerView: 4
          },
        },
      });
    });
  },

  /**
   * Faz a montagem do carousel dos banners de instagram
  */
  setBannersInstagram: () => {
    const bannersCategories = document.querySelectorAll('[data-instagram-swiper]');

    bannersCategories.forEach((section) => {
      const carousel = section.querySelector('.swiper');
      const next = section.querySelector('.swiper-button-instagram-next');
      const prev = section.querySelector('.swiper-button-instagram-prev');

      const swiper = new Swiper(carousel, {
        slidesPerView: 1,
        navigation: {
          nextEl: next,
          prevEl: prev,
        },
        watchOverflow: true,
        preloadImages: false,
        lazy: {
          checkInView: true,
          loadPrevNext: true,
          loadOnTransitionStart: true,
          loadPrevNextAmount: 1,
        },
        breakpoints: {
          1024: {
            slidesPerView: 5,
          },
          768: {
            slidesPerView: 3
          },
        },
      });
    });
  },

  /**
   * Faz a montagem do carousel da régua
  */
  setRuler: () => {
    const ruler = document.querySelectorAll('[data-ruler-swiper]');

    ruler.forEach((section) => {
      const carousel = section.querySelector('.swiper');

      const swiper = new Swiper(carousel, {
        slidesPerView: 1,
        loop: true,
        speed: 1000,
        autoplay: {
            delay: 5000
        },
        breakpoints: {
          1366: {
            slidesPerView: 5,
          },
          1024: {
            slidesPerView: 4,
          },
          768: {
            slidesPerView: 2
          },
        },
      });
    });
  },

  showcaseBanner: function(){
    const productsCarousel = document.querySelectorAll('[data-home-banner-showcase]');

    if(productsCarousel){
        productsCarousel.forEach((section) => {
            const carousel = section.querySelector('.swiper');
            const next = section.querySelector('.swiper-showcase-button-next');
            const prev = section.querySelector('.swiper-showcase-button-prev');
            const pagination = section.querySelector('.swiper-showcase-pagination');
        
            if (carousel) {
              const swiper = new Swiper(carousel, {
                slidesPerView: 2,
                preloadImages: false,
                loop: true,
                autoplay: {
                  delay: 5000
                },
                preloadImages: false,
                lazy: {
                  checkInView: true,
                  loadPrevNext: true,
                  loadOnTransitionStart: true,
                  loadPrevNextAmount: 1,
                },
                breakpoints: {
                  767: {
                    slidesPerView: 3,
                  }
                },
                pagination: {
                  el: pagination,
                  type: 'bullets',
                  clickable: true,
                },
                navigation: {
                    nextEl: next,
                    prevEl: prev,
                },
              });
            }
        });
    }
  },

  showcaseMainSpot: function(){
    const productsCarousel = document.querySelectorAll('[data-home-hit-showcase]');

    if(productsCarousel){
        productsCarousel.forEach((section) => {
            const carousel = section.querySelector('.swiper');
            const next = section.querySelector('.swiper-showcase-button-next');
            const prev = section.querySelector('.swiper-showcase-button-prev');
        
            if (carousel) {
                new Swiper(carousel, {
                    centeredSlides: true,
                    loop: true,
                    slidesPerView: 1.5,
                    preloadImages: false,
                    lazy: {
                      checkInView: true,
                      loadPrevNext: true,
                      loadOnTransitionStart: true,
                      loadPrevNextAmount: 7,
                    },
                    breakpoints: {
                      1023: {
                        slidesPerView: 5,
                      },
                      767: {
                        slidesPerView: 3,
                      }
                    },
                    navigation: {
                        nextEl: next,
                        prevEl: prev,
                    },
                });
            }
        });
    }
  },

  init: function(){
      const _this = this;

      _this.setFullbanner();
      _this.setBannersCategories();
      _this.setBannersBrands();
      _this.setBannersInstagram();
      _this.setRuler();
      _this.showcaseBanner();
      _this.showcaseMainSpot();
  },
}

export default homeFunctions;